import { useEffect } from 'react';
import { connect } from "react-redux";
import PropTypes from 'prop-types';
import { Row, Col } from "antd";
import TopbarWrapper from "./topbar.style";
import Logo from "../../components/utility/logo";
import TopbarUser from "./topbarUser";
import { MenuUnfoldOutlined, MenuFoldOutlined } from '@ant-design/icons';
import appActions from '../../redux/app/actions';

const { setIsHamburgerMenuCollapsed } = appActions;
const WIDTH_LIMIT_TO_ENABLE_MENU_COLLAPSE = 767;

function Topbar(props) {
  useEffect(() => {
    if (props.appWidth) {
      if (props.appWidth > WIDTH_LIMIT_TO_ENABLE_MENU_COLLAPSE) props.setIsHamburgerMenuCollapsed(false);
      else props.setIsHamburgerMenuCollapsed(true);
    } 

  // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [props.appWidth])

  return (
    <TopbarWrapper>
      <Row align={'middle'} style={{ display: 'flex', height: 64, backgroundColor: 'rgb(30, 135, 240)' }}>
        <Col style={{ display: 'flex', paddingLeft: 15, flex: '1 1' }}>
          <div style={{ marginRight: 10 }}>
            {props.isHambugerMenuCollapsed ?
              <MenuUnfoldOutlined style={{ color: "white", fontSize: "19px" }} onClick={() => props.setIsHamburgerMenuCollapsed(false)} /> :
              <MenuFoldOutlined style={{ color: "white", fontSize: "19px" }} onClick={() => props.setIsHamburgerMenuCollapsed(true)} />
            }
          </div>
          <Logo style={{ marginLeft: 10 }} />
        </Col>
        <Col style={{ display: 'flex', justifyContent: 'right', marginRight: 20, height: 64 }}>
          <TopbarUser />
        </Col>
      </Row>
    </TopbarWrapper>
  )
}

Topbar.propTypes = {
  appWidth: PropTypes.number,
  isHambugerMenuCollapsed: PropTypes.bool.isRequired,
  setIsHamburgerMenuCollapsed: PropTypes.func.isRequired
};

Topbar.defaultProps = {
  isHambugerMenuCollapsed: true
}

const mapActionsToProps = {
  setIsHamburgerMenuCollapsed
};

function mapStateToProps(state) {
  return {
    appWidth: state.App.get('appWidth'),
    isHambugerMenuCollapsed: state.App.get('isHambugerMenuCollapsed')
  };
}

const connectedApp = connect(mapStateToProps, mapActionsToProps)(Topbar);
export default connectedApp;
